import clientConfig from '../appconfig/clientConfig.json';
import { LoginResponse } from '../appojo/responsemodel/LoginResponse';

const RouteConstants = {
    DashBoard: 'DashBoardScreen',
    SplashScreen: 'SplashScreen',
    AccountScreen: 'AccountScreen',
    HistoryScreen: 'HistoryScreen',
    home: 'Home',
    LoginScreen: 'LoginScreen',
    RegisterScreen: 'RegisterScreen',
    OtpScreen: 'OtpScreen',
    ForgotPasswordScreen: 'ForgotPasswordScreen',
    WebsiteScreen: 'WebsiteScreen',
    WebViewScreen: 'WebViewScreen',
    SportsScreen: 'SportsScreen',
    ProfileScreen: 'ProfileScreen',
    SportsDetailScreen: 'SportsDetailScreen',
    SportsBookingScreen: 'SportsBookingScreen',
    EventDetailScreen: 'EventDetailScreen',
    EventBookingScreen: 'EventBookingScreen',
    EventsScreen: 'EventsScreen',
    PaymentScreen: 'PaymentScreen',
    TicketScreen: 'TicketScreen',
    MovieDetailScreen: 'MovieDetailScreen',
    MovieScreen: 'MovieScreen',
    UpcomingMoviesScreen: 'UpcomingMoviesScreen',
    TheatersViewScreen: 'TheatersViewScreen',
    ShowTimeScreen: 'ShowTimeScreen',
    AboutMovieScreen: 'AboutMovieScreen',
    DetailScreen: 'DetailScreen',
    previousMenu: 'previousMenu',
    BusDashboardScreen: 'BusDashboardScreen',
    BusSearchScreen: 'BusSearchScreen',
    SelectSeatScreen: 'SelectSeatScreen',
    BoardingDropingScreen: 'BoardingDropingScreen',
    PassangerInfoScreen: 'PassangerInfoScreen',



    PaymentOption: 'PaymentOption',

    QrCodeScreen: 'QrCodeScreen',
    Sendmoneyqrscreen: 'Sendmoneyqrscreen',
    UserImageScreen: 'UserImageScreen',
    PayOrScanScreen: 'PayOrScanScreen',
    ToContactScreen: 'ToContactScreen',

    ProfilePictureScreen: 'ProfilePictureScreen',
    UserPasswordScreen: 'UserPasswordScreen',
    ResetPasswordScreen: 'ResetPasswordScreen',
    Accounts: 'Accounts',
    ScannerHome: 'ScannerHome',
    ScannerScreen: 'ScannerScreen',
    ScanDetailsScreen: 'ScanDetailsScreen',

}
const checkLoginData = (user) => {
    if (user != null) {
        if (user.id != null) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}
const checkRole = (user) => {
    const loginResponse = new LoginResponse(user);
    if (loginResponse != null) {
        if (loginResponse.loginid != null) {
            if (loginResponse.rolesName === 'Scanner Agent') {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    } else {
        return false;
    }
}

const printConsole = (input) => {
    if (clientConfig.isConsole) {
        console.log(input);
    }
}

export {
    RouteConstants, checkLoginData, printConsole, checkRole
}

